// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2415q","containerItemsCenter":"Skeleton_containerItemsCenter__1T6Qi"};